// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + "403f560827cd380cf454" + ".css";
};